import { FC, useEffect, useState } from 'react'
import {
    Alert,
    Button,
    Col,
    Form,
    InputGroup,
    Row,
    Tab,
    Tabs,
} from 'react-bootstrap'
import { useAppSelector } from '../../../../store/hooks'
import { Language } from '../../../../features/security/security.slice'
import { ctaStyles, urlTypes } from '../../Constants'
import { CtaProps, CtaType } from '../Forms.d'
import DeleteDialog from '../../dialogs/DeleteDialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

const Cta: FC<CtaProps> = ({
    cta,
    formikProps,
    translations,
    availablePages,
    setVisible,
    deletedCtas,
    setDeletedCtas,
    setCtaIsValid,
}) => {
    const [originalCta] = useState(cta)
    const theme = useAppSelector((state) => state.theme.theme)
    const initData = useAppSelector((state: any) => state.security.initData)
    const [localCta, setLocalCta] = useState<CtaType>(cta)
    const [firstInternalPageId, setFirstInternalPageId] = useState<
        number | null
    >(null)
    const [validationErrors, setValidationErrors] = useState<object>({})

    const [isNew] = useState(cta.id?.toString().substring(0, 3) === 'new')

    const { id } = cta
    const { values, setFieldValue } = formikProps

    useEffect(() => {
        setFieldValue('ctas', {
            ...values.ctas,
            [id]: localCta,
        })
        // eslint-disable-next-line
    }, [localCta])

    useEffect(() => {
        const selectedVal = availablePages.filter((obj: any, index: number) => {
            return index === 0
        })

        setFirstInternalPageId(selectedVal[0]?.['id'] || '')
    }, [availablePages])

    const validateForm = () => {
        return new Promise((resolve, reject) => {
            setValidationErrors({})

            let errors = {}
            const divElem = document.getElementById(`form-cta-${cta.id}`)
            const inputElements = divElem
                ? divElem.getElementsByTagName('input')
                : null

            for (var i = 0, n = inputElements.length; i < n; i = i + 1) {
                const isRequired = inputElements[i].required
                const value = inputElements[i].value
                const fieldName =
                    inputElements[i].getAttribute(
                        'data-validation-field-name'
                    ) || inputElements[i].name

                if (isRequired && !value && fieldName) {
                    errors = {
                        ...errors,
                        [fieldName]: `Field ${fieldName} is required!`,
                    }
                }
            }

            // const selectElements = divElem
            //     ? divElem.getElementsByTagName('select')
            //     : null

            // for (var i = 0, n = selectElements.length; i < n; i = i + 1) {
            //     // console.log('select: ', selectElements[i].value)
            //     // console.log('select: ', selectElements[i].required)
            // }

            resolve(errors)
        })
    }

    const footerContent = (
        <div>
            <Button
                variant={theme === 'dark' ? 'dark' : 'light'}
                onClick={() => {
                    if (originalCta.label)
                        formikProps.setFieldValue('ctas', {
                            ...formikProps.values.ctas,
                            [cta.id]: originalCta,
                        })
                }}
                className="border"
            >
                Reset
            </Button>
            <DeleteDialog
                record={cta}
                deletedCallback={() => setVisible(false)}
                btnLabel={
                    isNew
                        ? 'Delete'
                        : deletedCtas.includes(cta.id)
                        ? 'Un-mark deleted'
                        : 'Mark as deleted'
                }
                showIcon={false}
                doDelete={() => {
                    if (isNew) {
                        const ctas = values.ctas
                        delete ctas[cta.id]
                        setFieldValue('ctas', ctas)
                    } else {
                        if (!deletedCtas.includes(cta.id)) {
                            setDeletedCtas([...deletedCtas, cta.id])
                        } else {
                            setDeletedCtas(
                                deletedCtas.filter((ctaId) => ctaId !== cta.id)
                            )
                        }
                    }

                    setVisible(false)
                }}
                message={
                    <>
                        <p className="mt-3">
                            Are you sure you want{' '}
                            {isNew
                                ? 'delete this action'
                                : deletedCtas.includes(cta.id)
                                ? 'to un-mark this action as deleted'
                                : 'to mark this action as deleted'}
                            ?
                        </p>
                        {!deletedCtas.includes(cta.id) ? (
                            <Alert variant="warning">
                                <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    className="me-2"
                                />
                                <strong>Note:</strong> The action will be
                                deleted only after you've updated the record.
                            </Alert>
                        ) : (
                            <></>
                        )}
                    </>
                }
            />
            <Button
                variant="success"
                onClick={() => {
                    validateForm().then((errors: any) => {
                        setValidationErrors((prevState) => {
                            return {
                                ...prevState,
                                ...errors,
                            }
                        })
                        if (Object.keys(errors).length <= 0) {
                            setDeletedCtas(
                                deletedCtas.filter(
                                    (id) => id.toString() !== cta.id.toString()
                                )
                            )
                            setCtaIsValid(true)
                            setVisible(false)
                        }
                    })
                }}
                className="p-button-text"
            >
                Finish
            </Button>
        </div>
    )

    return (
        <>
            <div
                className="bg-gray p-3 shadow border mb-4"
                id={`form-cta-${cta.id}`}
            >
                {Object.keys(validationErrors).length > 0 ? (
                    <Alert variant="danger">
                        {Object.values(validationErrors)?.map(
                            (error, index) => {
                                return <div key={index}>{error}</div>
                            }
                        )}
                    </Alert>
                ) : (
                    <></>
                )}
                <Form.Group controlId={`cta_${id}_active`}>
                    <Form.Switch
                        type="checkbox"
                        label={localCta.active ? 'De-Activate' : 'Activate'}
                        checked={localCta.active}
                        className="float-end"
                        onChange={(e) => {
                            setLocalCta({
                                ...localCta,
                                active: e.target.checked,
                            })
                        }}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="Cta_1">
                    <Tabs id={`_header_cta${id}_fieldTabs`} className="mb-0">
                        {Object.keys(initData.languages.data).map((locale) => {
                            const lang: Language =
                                initData.languages.data[locale]
                            const title = translations?.[
                                locale
                            ]?.hasOwnProperty(lang.name)
                                ? translations[locale][lang.name]
                                : lang.name

                            const ctaLabelProp = `header_cta_${id}_label_${lang.id}`

                            return (
                                <Tab
                                    eventKey={locale}
                                    title={title}
                                    key={locale}
                                    className="fade border-start border-end border-bottom mb-3 p-2"
                                >
                                    {typeof values.ctas[id] !== 'undefined' && (
                                        <Form.Control
                                            type="text"
                                            name={ctaLabelProp}
                                            value={
                                                values.ctas[id][ctaLabelProp] ||
                                                ''
                                            }
                                            onChange={(e) => {
                                                setLocalCta({
                                                    ...localCta,
                                                    [ctaLabelProp]:
                                                        e.target.value,
                                                })
                                            }}
                                            placeholder={`Entere label (${lang.name})`}
                                            required
                                            data-validation-field-name={`Label (${lang.name})`}
                                        />
                                    )}
                                </Tab>
                            )
                        })}
                    </Tabs>
                </Form.Group>

                <Form.Group className="mb-3" controlId="header_cta1_url">
                    <InputGroup className="mb-3">
                        <Form.Select
                            value={localCta.url_type}
                            size="sm"
                            style={{
                                width: '30%',
                            }}
                            onChange={(e) => {
                                setLocalCta({
                                    ...localCta,
                                    url_type: e.target.value,
                                    url_id: firstInternalPageId,
                                })
                            }}
                            required
                        >
                            {urlTypes.map((choice: any) => (
                                <option key={choice.id} value={choice.id}>
                                    {choice.name}
                                </option>
                            ))}
                        </Form.Select>
                        {localCta.url_type === 'internal' ? (
                            <Form.Select
                                value={localCta.url_id}
                                size="sm"
                                style={{
                                    width: '70%',
                                }}
                                onChange={(e) => {
                                    const urlId = parseInt(e.target.value)
                                    const selectedVal = availablePages.filter(
                                        (obj: any) => {
                                            return parseInt(obj.id) === urlId
                                        }
                                    )

                                    const url =
                                        selectedVal.length === 1
                                            ? selectedVal[0]['code']
                                            : ''

                                    setLocalCta({
                                        ...localCta,
                                        url: url,
                                        url_id: urlId,
                                    })
                                }}
                                required
                                data-validation-field-name="Url"
                            >
                                {(() => {
                                    const groups: Record<string, any[]> = {}
                                    availablePages.forEach((choice: any) => {
                                        const group = choice.group || 'Pages'
                                        if (!groups[group]) groups[group] = []
                                        groups[group].push(choice)
                                    })
                                    const formatLabel = (choice: any) =>
                                        choice.description
                                            ? `${choice.name} (${choice.description})`
                                            : choice.name
                                    const groupKeys = Object.keys(groups)
                                    if (groupKeys.length <= 1) {
                                        return availablePages.map((choice: any) => (
                                            <option key={choice.id} value={choice.id}>
                                                {formatLabel(choice)}
                                            </option>
                                        ))
                                    }
                                    return groupKeys.map((group) => (
                                        <optgroup key={group} label={group}>
                                            {groups[group].map((choice: any) => (
                                                <option key={choice.id} value={choice.id}>
                                                    {formatLabel(choice)}
                                                </option>
                                            ))}
                                        </optgroup>
                                    ))
                                })()}
                            </Form.Select>
                        ) : (
                            <Form.Control
                                value={localCta.url}
                                size="sm"
                                style={{
                                    width: '70%',
                                }}
                                onChange={(e) => {
                                    setLocalCta({
                                        ...localCta,
                                        url: e.target.value,
                                    })
                                }}
                                required
                                data-validation-field-name="Url"
                            />
                        )}
                    </InputGroup>
                </Form.Group>

                <Row>
                    <Col xl={6}>
                        <Form.Group className="mb-3" controlId="headerCtaStyle">
                            <Form.Select
                                size="sm"
                                value={localCta.style}
                                onChange={(e) => {
                                    setLocalCta({
                                        ...localCta,
                                        style: e.target.value,
                                    })
                                }}
                                required
                            >
                                {ctaStyles.map((choice: any) => (
                                    <option key={choice.id} value={choice.id}>
                                        {choice.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xl={6}>
                        <Form.Group
                            className="mb-3"
                            controlId="header_cta1_order"
                        >
                            <Form.Control
                                size="sm"
                                type="number"
                                name="order"
                                value={localCta.order || ''}
                                onChange={(e) => {
                                    setLocalCta({
                                        ...localCta,
                                        order: parseInt(e.target.value),
                                    })
                                }}
                                data-validation-field-name="Order"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </div>
            <div className="p-dialog-footer p-0 pt-3">{footerContent}</div>
        </>
    )
}

export default Cta
